import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OfficeService } from '../../../shared/_services/office.service';
import { CityService } from '../../../shared/_services/city.service';
import { Office, MissingData } from '../../../shared/models/missingdata.model';
import { City } from '../../../shared/models/missingdata.model';
import { FileService } from '../../../shared/_services/file.service';

@Component({
  selector: 'app-fill-offices',
  templateUrl: './fill-offices.component.html',
  styleUrls: ['./fill-offices.component.css']
})
export class FillOfficesComponent implements OnInit {

  officeList: Office[];
  cities: City[];
  btnText: string;

  constructor(
    private officeService: OfficeService,
    private fileService: FileService,
    private cityService: CityService,
    private router: Router
  ) { }

  ngOnInit() {
    this.fileService.getMissingData()
      .subscribe((res: MissingData) => {
        this.officeList = res.listMissingOffices as Office[];
        if (this.officeList === null || this.officeList.length < 1) {
          this.router.navigate(['/manage-file/fill-agents']);
        } else {
          this.cityService.getCities()
            .subscribe(cities => {
              this.cities = cities
            });    
          this.btnText = this.fileService.checkStep(2,res) ? 'Siguiente' : 'Finalizar'
        }
      }, error => {
        console.log(error)
        this.router.navigate(['/']);
      });
  }

  onSubmit() {
    this.officeService.saveOffices(this.officeList)
      .subscribe((res: any) => { console.log(res) }, err => console.log(err));
    //console.log(this.officeList);
    this.router.navigate(['/manage-file/fill-agents']);
  }

}
